import { blue, blueDark, red, textMuted, white } from '@/theme/colors'
import styled from 'styled-components'

/**
 * Shared styles for the admin resource lists (Events, Ideas, Expenses). Rows are
 * clickable and navigate to the matching detail page, so `Row` carries hover +
 * pointer affordances. Users/Trips keep their own (older) style modules.
 */

export const Toolbar = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	margin-bottom: 1.25rem;
	flex-wrap: wrap;
`

export const SearchInput = styled.input`
	flex: 1;
	min-width: 220px;
	max-width: 360px;
	padding: 0.55rem 0.75rem;
	border: 1px solid ${textMuted}33;
	border-radius: 8px;
	font-size: 0.95rem;
	background-color: ${white};

	&:focus {
		outline: none;
		border-color: ${blue};
	}
`

export const ResultCount = styled.span`
	color: ${textMuted};
	font-size: 0.9rem;
`

export const TableWrap = styled.div`
	background-color: ${white};
	border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	overflow-x: auto;
`

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	font-size: 0.92rem;
`

export const Th = styled.th`
	text-align: left;
	padding: 0.85rem 1rem;
	font-weight: 600;
	color: ${textMuted};
	border-bottom: 1px solid ${textMuted}22;
	white-space: nowrap;
`

export const Td = styled.td`
	padding: 0.8rem 1rem;
	border-bottom: 1px solid ${textMuted}14;
	color: ${blue};
	white-space: nowrap;
`

export const Row = styled.tr<{ $deleted?: boolean }>`
	cursor: pointer;
	background-color: ${({ $deleted }) => ($deleted ? `${red}10` : 'transparent')};
	transition: background-color 0.12s ease;

	&:hover {
		background-color: ${({ $deleted }) => ($deleted ? `${red}1f` : `${blue}0d`)};
	}

	&:last-child td {
		border-bottom: none;
	}
`

export const Muted = styled.span`
	color: ${textMuted};
`

export const SubText = styled.div`
	color: ${textMuted};
	font-size: 0.82rem;
	margin-top: 0.15rem;
`

export const DeletedTag = styled.span`
	display: inline-block;
	margin-left: 0.5rem;
	padding: 0.1rem 0.45rem;
	border-radius: 6px;
	background-color: ${red};
	color: ${white};
	font-size: 0.72rem;
	font-weight: 700;
	vertical-align: middle;
`

export const ScopeTag = styled.span<{ $personal?: boolean }>`
	display: inline-block;
	padding: 0.1rem 0.45rem;
	border-radius: 6px;
	background-color: ${({ $personal }) => ($personal ? `${textMuted}22` : `${blue}1a`)};
	color: ${({ $personal }) => ($personal ? textMuted : blueDark)};
	font-size: 0.72rem;
	font-weight: 700;
`

export const Pagination = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;
	margin-top: 1.25rem;
`

export const PageButton = styled.button`
	padding: 0.5rem 0.9rem;
	border: 1px solid ${blue};
	border-radius: 8px;
	background-color: ${white};
	color: ${blue};
	font-weight: 600;
	cursor: pointer;

	&:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}
`

export const PageStatus = styled.span`
	color: ${textMuted};
	font-size: 0.9rem;
`

export const EmptyState = styled.div`
	padding: 2.5rem 1rem;
	text-align: center;
	color: ${textMuted};
`

export const ErrorState = styled.div`
	color: ${textMuted};
	font-size: 1rem;
`
